module["exports"] = [
  "9##-###-###",
  "9##.###.###",
  "9## ### ###",
  "9########"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/phone_number/formats.js
 ** module id = 612
 ** module chunks = 0
 **/